import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { memo, useMemo } from "react";
import { ImgixImage } from "~/components/ImgixImage";
import { getCloudFrontUrlFromImgixUrl } from "~/constants/cloudfront";
import { THUMBNAIL_HEIGHT } from "../../../shared/constants";
const THUMBNAIL_WIDTH = 112;
const IMGX_OPTIONS = {
    fit: "crop",
    auto: "compress",
    cs: "origin",
    w: THUMBNAIL_WIDTH,
    h: THUMBNAIL_HEIGHT
};
export const VersionImageThumbnail = /*#__PURE__*/ memo((param)=>{
    let { src, isCurrentVersion } = param;
    const fallbackUrl = useMemo(()=>{
        if (src) return getCloudFrontUrlFromImgixUrl(src);
        return "";
    }, [
        src
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: classNames("asset-modal-version-thumbnail pointer-events-none box-border w-full overflow-hidden rounded-2 border border-black", isCurrentVersion ? "shadow-[0px_0px_0px_2px] shadow-grey-10" : ""),
        style: {
            height: THUMBNAIL_HEIGHT
        },
        children: /*#__PURE__*/ _jsx(ImgixImage, {
            className: "pointer-events-none object-cover",
            alt: "",
            src: src,
            fallbackUrl: fallbackUrl,
            imgixParams: IMGX_OPTIONS,
            height: THUMBNAIL_HEIGHT,
            width: THUMBNAIL_WIDTH
        })
    });
});
VersionImageThumbnail.displayName = "VersionImageThumbnail";
